import Raven from 'raven-js';
import { useCallback } from 'react';
import { sendFeedbackApi } from '../../../api/ChatSpotV1Api';
import { updateFeedback } from '../../../api/CopilotV2FeedbackApi';
import { useIsUngatedForCopilotV2 } from '../../../hooks/useIsUngatedForCopilotV2';

// TODO - remove this mapping logic once V2 is fully launched
const TAG_MAP_COPILOT_V1_TO_V2 = {
  incorrectAction: 'INCORRECT_ACTION',
  notRelevant: 'NOT_RELEVANT',
  incomplete: 'INCOMPLETE',
  inaccurate: 'INACCURATE',
  other: 'OTHER'
};
const convertCopilotV1FeedbackToCopilotV2Feedback = ({
  messageId,
  options = [],
  feedbackMessage,
  threadId,
  vote
}) => {
  const isPositiveFeedback = vote === 1;
  const messageIdString = messageId.toString();
  if (isPositiveFeedback) {
    return {
      messageId: messageIdString,
      threadId,
      feedback: {
        polarity: 'POSITIVE',
        tags: []
      }
    };
  }
  const formattedCopilotV2Options = options === null || options === void 0 ? void 0 : options.map(option => {
    return TAG_MAP_COPILOT_V1_TO_V2[option];
  });
  return {
    messageId: messageIdString,
    threadId,
    feedback: {
      polarity: isPositiveFeedback ? 'POSITIVE' : 'NEGATIVE',
      tags: isPositiveFeedback ? [] : formattedCopilotV2Options,
      comment: feedbackMessage
    }
  };
};
export const useInlineFeedback = () => {
  const isUngatedForCopilotV2 = useIsUngatedForCopilotV2();
  const handlePositiveFeedback = useCallback(({
    messageId,
    threadId,
    vote
  }) => {
    if (isUngatedForCopilotV2) {
      const copilotV2FeedbackPayload = convertCopilotV1FeedbackToCopilotV2Feedback({
        messageId,
        threadId,
        vote
      });
      updateFeedback(copilotV2FeedbackPayload).catch(error => {
        Raven.captureException(new Error('Failed to send positive feedback', error));
      });
    } else {
      sendFeedbackApi({
        messageId,
        vote
      }).catch(error => {
        Raven.captureException(new Error('Failed to send positive feedback', error));
      });
    }
  }, [isUngatedForCopilotV2]);
  const handleNegativeFeedback = useCallback(({
    messageId,
    threadId,
    options,
    feedbackMessage,
    vote
  }) => {
    if (isUngatedForCopilotV2) {
      const copilotV2FeedbackPayload = convertCopilotV1FeedbackToCopilotV2Feedback({
        messageId,
        threadId,
        options,
        feedbackMessage,
        vote
      });
      updateFeedback(copilotV2FeedbackPayload).catch(error => {
        Raven.captureException(new Error('Failed to send negative feedback', error));
      });
    } else {
      sendFeedbackApi({
        messageId,
        options,
        feedbackMessage,
        vote
      }).catch(error => {
        Raven.captureException(new Error('Failed to send negative feedback', error));
      });
    }
  }, [isUngatedForCopilotV2]);
  return {
    onPositiveFeedback: handlePositiveFeedback,
    onNegativeFeedback: handleNegativeFeedback
  };
};